var caseStatusTags = {
    opened: 'Claim Opened',
    review: 'Under Review',
    completed: 'Dispute Completed',
    cancelationPending: 'Cancelation Pending',
    canceled: 'Dispute Canceled',
    lowBalance: 'Low Balance'
};
export default caseStatusTags;
//# sourceMappingURL=caseStatusTags.js.map